import axios from "axios";

const REST_API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/product`;

export const listProducts = () =>
  axios.get(REST_API_BASE_URL, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const createProduct = (product) =>
  axios.post(REST_API_BASE_URL, product, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const updateProduct = (productId, product) =>
  axios.put(`${REST_API_BASE_URL}/${productId}`, product, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getProduct = (productId) =>
  axios.get(`${REST_API_BASE_URL}/${productId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const deleteProduct = (productId) =>
  axios.delete(`${REST_API_BASE_URL}/${productId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const deleteAllProducts = () =>
  axios.delete(`${REST_API_BASE_URL}/deleteAll`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

export const getInventorySummary = () =>
  axios.get(`${REST_API_BASE_URL}/inventory-summary`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

/**
 * Fetch all unique product categories.
 * Backend endpoint: GET /api/product/categories
 * Returns: Array of strings (category names)
 */
export const listCategories = () =>
  axios.get(`${REST_API_BASE_URL}/categories`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

/**
 * Fetch inventory share grouped by category for the pie chart.
 */
export const getInventoryShare = (limit = 5) => {
  return axios.get(`${REST_API_BASE_URL}/inventory-share`, {
    params: { limit },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Restock a product by adding the provided quantity to the existing stock.
 */
export const restockProduct = (productId, restockPayload) =>
  axios.patch(`${REST_API_BASE_URL}/${productId}/restock`, restockPayload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });

/**
 * Fetch the update history for a specific product.
 */
export const getProductHistory = (productId) =>
  axios.get(`${REST_API_BASE_URL}/${productId}/history`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  });
